import { WEB_COMPONENT_CHILD_GROUPS_GRID } from '../../../../../webcomponents.constants';
import { ChildGroupsGridWebComponent } from './component/ChildGroupsGridWebComponent';

window.customElements.define(WEB_COMPONENT_CHILD_GROUPS_GRID, ChildGroupsGridWebComponent);

export { ChildGroupsGridWebComponent };
